import React from 'react';
import { TextField as MaterialTextField } from '@mui/material';
import { useField } from 'formik';
import _ from 'lodash';

const TextFieldInput = React.memo(
    (props) => (
        <>
            <MaterialTextField {...props} />
        </>
    ),
    (prevProps, nextProps) => _.isEqual(prevProps, nextProps)
);

function TextField({ label, controlled = false, showErrorText = true, ...props }) {
    const [{ value, ...field }, meta] = useField(props);
    return (
        <TextFieldInput
            fullWidth
            variant="outlined"
            size="small"
            error={meta.touched && !!meta.error}
            {...(showErrorText ? { helperText: meta.touched && !!meta.error ? meta.error : ' ' } : {})}
            label={label}
            value={value}
            {...field}
            {...props}
        />
    );
}

export default React.memo(TextField);
